import { createSlice } from "@reduxjs/toolkit";

const videoSlice = createSlice({
  name: "video",
  initialState: {
    videos: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    getVideoLessonStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getVideoLessonSuccess: (state, action) => {
       
      state.isFetching = false;
      state.videos = action.payload;
      state.error = false;
    },
    getVideoLessonFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
   updateWatchTimeSuccess: (state, action) => {
      state.isFetching = false;
      state.videos[
        state.videos.findIndex((item) => item._id === action.payload.videoId)
      ]["watchTime"] = action.payload;
      state.error = false;
    }
  },
});

export const {
  getVideoLessonFailure,
  getVideoLessonSuccess,
  getVideoLessonStart, 
  updateWatchTimeSuccess
} = videoSlice.actions;
export default videoSlice.reducer;